import { inject, Injectable } from '@angular/core';
import { AppConfigService, buildParameters, Page } from '@markant-platform/shared/data-access';
import { HttpClient } from '@angular/common/http';
import { PlatformRequestUser, PlatformRequestUserFilterParameters } from '@markant-platform/shared/user/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPlatformRequestService {
  userPlatformRequestApiUrl: string = AppConfigService.appConfiguration.apiUrl['userPlatformRequest'];

  private readonly http = inject(HttpClient);

  getPlatformRequestUsers(
    platformRequestId: string,
    parameters: PlatformRequestUserFilterParameters
  ): Observable<Page<PlatformRequestUser>> {
    const params = buildParameters({
      'sort-field': parameters.sort?.sortField,
      'sort-order': parameters.sort?.sortOrder,
      query: parameters.search,
      index: parameters.page?.index,
      size: parameters.page?.size,
    });
    return this.http.get<Page<PlatformRequestUser>>(`${this.userPlatformRequestApiUrl}/${platformRequestId}/users`, {
      params,
    });
  }
}
